import { Box, Button, Card } from '@mui/material';
import React, { useState } from 'react'
import Breadcrumb from '../../../../layouts/full-layout/breadcrumb/Breadcrumb';
import FeatherIcon from "feather-icons-react";
import { getAddNewResumeObj } from './EmptyAddResume';
import { Form, FormikProvider, useFormik } from 'formik';
import { AddCandidate, AddCV } from './AddCV';
import CVValidation from '../../../../validationSchema/AddCV';
import { AddCandidateCV } from '../../../../services/human-resource';
import { toast } from 'react-toastify';

export const AddResume = () => {
      const [selectCandidate, setSelectCandidate] = useState(getAddNewResumeObj());
    
    const BCrumb = [
        {
          to: "/",
          title: "HR Management",
        },
        {
          title: "Add CV",
        },
      ];
      const formik = useFormik({
        initialValues: selectCandidate,
        onSubmit(values, { resetForm }) {
          addResume(values, resetForm);
        },
        enableReinitialize: true,
        validationSchema:CVValidation,
      });

      const addResume = async (values, resetForm) => {
        const formData = new FormData();
        formData.append("FirstName", values?.firstName);
        formData.append("MiddleName", values?.middleName);
        formData.append("LastName", values?.lastName);
        formData.append("Attachment", values?.cv);
        try {
          const response = await AddCandidateCV(formData);
            if (response?.status === 200) {
                toast.success("CV Added Successfully");
                resetForm();
            }
        }
        catch(e){
          console.log(e);
        }
      };
      const { handleChange, setFieldValue, values } = formik;

  return (
    <>
      <Breadcrumb
        title={"Add CV"}
        items={BCrumb}
      />
      <Card
        sx={{
          p: 0,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>Add CV</Box>
        </Box>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <Card>
                <AddCV
                  values={values}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                 
                />
              </Card>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              
              
                <Button variant="contained" color="primary" type="submit">
                  Save
                </Button>
             
            </Box>
          </Form>
        </FormikProvider>
        </Card>
        </>
  )
}
